export default defineNuxtRouteMiddleware((to) => {
  const { status: authStatus, data: user } = useAuth()
  // This should never happen, but just in case.
  // The user should always be authenticated (checked by the auth middleware)
  if (!user.value || authStatus.value !== 'authenticated') {
    // Otherwise, redirect to the login page
    return navigateTo('/login')
  }

  // if skills is next path
  // only show to users who are authorized
  if (user.value && authStatus.value === 'authenticated') {
    if (to.fullPath.includes('/skills')) {
      const canAccess = isUserAccessSkillsWithAlert(user.value)
      if (!canAccess) navigateTo(getHomePage(user.value))
    }
  }
})
